module.exports = __webpack_public_path__ + "img/24-7-monitoring-icon.5496610d.png";